import React from "react";
import Typography from "@mui/material/Typography";

import { ExternalLink } from "src/library/components/exports";

export default function Copyright() {
  return (
    <Typography variant="caption" color="text">
      {"Copyright "}&copy;{" "}
      <ExternalLink link="https://entaingroup.com" text="" style={{ color: "white" }}>
        <Typography variant="caption">Entain</Typography>
      </ExternalLink>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
